<template>
    <section class="single betSlip _singleTicket _singleMode notranslate">
        <header class="single-header">
            <div class="single-headerInfo">
                <span class="single-ticketCount">{{ TICKET_COUNT }}</span>
                <span class="single-title">{{ headerTitle }}</span>
                <SboIcon class="single-questionIcon" name="system:questionOutline" />
            </div>
            <div class="single-actions">
                <button class="single-clear" type="button">
                    <SboIcon name="system:trashOutline" size="20" />
                </button>
                <button class="single-expand" type="button">
                    <SboIcon name="system:expand" size="20" />
                </button>
            </div>
            <button class="single-collapse" type="button">
                <SboIcon name="system:arrowDown" size="20" />
            </button>
        </header>
        <ul class="tab tab-betSlip">
            <li class="tab-item" v-bind:class="{ _active: !isShowParlaySlip }">
                {{ singleTabText }}
            </li>
            <li class="tab-item" v-bind:class="{ _active: isShowParlaySlip }">
                {{ parlayTabText }}
            </li>
        </ul>
        <div v-if="!isShowParlaySlip" class="multipleSingleBetSlip">
            <div
                v-for="ticket in TICKET_COUNT"
                v-bind:key="ticket"
                class="ticketContainer"
            >
                <article class="singleModeTicket ticketSkeleton">
                    <span class="ticketSkeleton-block _league" />
                    <span class="ticketSkeleton-block _match" />
                    <div class="ticketSkeleton-row">
                        <span class="ticketSkeleton-block _market" />
                        <span class="ticketSkeleton-block _price" />
                    </div>
                    <div class="ticketSkeleton-row">
                        <span class="ticketSkeleton-block _payout" />
                        <span class="ticketSkeleton-block _stakeBox" />
                    </div>
                </article>
            </div>
        </div>
        <div v-else class="parlayInSingleBetSlip">
            <div
                v-for="ticket in TICKET_COUNT"
                v-bind:key="ticket"
                class="parlayTicket"
            >
                <article class="singleModeTicket ticketSkeleton">
                    <span class="ticketSkeleton-block _league" />
                    <span class="ticketSkeleton-block _match" />
                    <div class="ticketSkeleton-row">
                        <span class="ticketSkeleton-block _market" />
                        <span class="ticketSkeleton-block _price" />
                    </div>
                </article>
            </div>
        </div>
        <footer class="single-footer">
            <div v-if="!isShowParlaySlip" class="single-footerCard footerSkeleton">
                <span class="ticketSkeleton-block _cta" />
            </div>
            <div v-else class="parlay-footerCard footerSkeleton">
                <div class="ticketSkeleton-block _parlayCtaGroup">
                    <span class="ticketSkeleton-block _parlayStake" />
                    <span class="ticketSkeleton-block _parlayCta" />
                </div>
            </div>
        </footer>
    </section>
</template>

<script lang="ts" setup>
    import { useIntervalFn, useToggle } from '@vueuse/core';
    import { computed } from 'vue';
    import SboIcon from '@/components/common/SboIcon.vue';
    import { i18n } from '@/libraries/i18n';

    const TICKET_COUNT = 3;
    const PARLAY_MOCK_ODDS = '4.913';
    const TAB_SWITCH_INTERVAL = 2000;

    const [isShowParlaySlip, toggleParlaySlip] = useToggle(false);

    const singleTabText = computed(() => i18n.t('bet_slip_tab_single'));
    const parlayTabText = computed(() => i18n.t('bet_slip_tab_parlay'));
    const headerTitle = computed(() => (isShowParlaySlip.value
        ? `${i18n.t('betSlip_comboParlay_option_3')} @ ${PARLAY_MOCK_ODDS}`
        : i18n.t('bet_slip_header_name')));

    useIntervalFn(toggleParlaySlip, TAB_SWITCH_INTERVAL);
</script>

<style lang="scss" scoped>
@import "@/scss/components/betSlip";
@import "@/scss/components/tab";
@import "@/scss/components/singleMode/single";
@import "@/scss/components/singleMode/singleTicket";
@import "@/scss/components/singleMode/multipleSingleBetSlip";
@import "@/scss/components/singleMode/parlayInSingleBetSlip";
@import "@/scss/components/betSlipTutorial/betSlipMock";
</style>
